import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Locale data (es-US) is registered by `provideI18n()` (app/core/i18n/i18n.providers.ts).
bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
